import React, { memo } from 'react';
import type { Store } from 'redux';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { Skeleton } from './skeleton/index.tsx';

const LazyPlanSettingsSidebar = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-plan-settings" */ './main'
		).then(({ PlanSettingsSidebar }) => PlanSettingsSidebar),
	{ entryFsSsrLiftImportToModule: false },
);

type Props = {
	store?: Store<State>;
};

const AsyncSidebar = ({ store }: Props): React.JSX.Element => (
	<Placeholder name="asyncSidebarPlanSettings" fallback={<Skeleton />}>
		<LazyPlanSettingsSidebar store={store} />
	</Placeholder>
);

export default memo(AsyncSidebar);
